import React, { useState } from "react";
import { Group, Button, Title, Box } from "@mantine/core";
import { Minus, UserPlus } from "tabler-icons-react";
import { ClientListing } from "./ClientListing";
import AddClientModal from "./AddClient";
import ClientProfilePage from "./ClientProfile/ClientProfilePage";
import { showNotification } from "@mantine/notifications";
import UpdateClientModal from "./updateClient";
import { PermissionButton } from "api/permission/buttonpermission";

export function Client() {
  const [opened, setOpened] = useState(false);
  const openClientProfile = (clientId: string, name: string) => {
    console.log(clientId, name);
    showNotification({
      title: "Unavailable",
      message: "This feature is not available.",
      icon: <Minus />,
      color: "red",
    });
  };
  return (
    <Box p="lg">
      <Group position="apart" mb="md">
        <Title order={2}>Clients</Title>
        <Group>
          <PermissionButton
            permission="ourClients"
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add Client
          </PermissionButton>
        </Group>
      </Group>

      <ClientListing onViewProfile={openClientProfile} />
      <AddClientModal opened={opened} onClose={() => setOpened(false)} />
    </Box>
  );
}
